import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';

const FAQPage = () => {
  const faqs = [
    { q: 'Is Profind.ca free to use?', a: 'Yes! Profind.ca is 100% free for homeowners. You can request quotes and connect with professionals at no cost.' },
    { q: 'How do I request a quote?', a: 'Simply search for the service you need, browse professionals, and click "Request Quote" on their profile. Fill out the form with your project details.' },
    { q: 'Are the professionals verified?', a: 'Yes, we verify all professionals on our platform to ensure quality and reliability.' },
    { q: 'How quickly will I receive quotes?', a: 'Most professionals respond within 24-48 hours. You\'ll receive notifications when quotes arrive.' },
    { q: 'Can I compare multiple quotes?', a: 'Absolutely! Request quotes from multiple pros and compare their offers, ratings, and reviews.' },
    { q: 'What if I\'m not satisfied?', a: 'Contact our support team at support@profind.ca and we\'ll help resolve any issues.' },
    { q: 'How do professionals join?', a: 'Professionals can sign up through our "Join as a Pro" page and choose a subscription plan that fits their needs.' },
    { q: 'What payment methods are accepted?', a: 'We accept all major credit cards through our secure Stripe payment processor.' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-6 text-center">Frequently Asked Questions</h1>
        <p className="text-lg text-gray-600 mb-12 text-center">Find answers to common questions about Profind.ca</p>
        
        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <Card key={idx}>
              <CardContent className="p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{faq.q}</h3>
                <p className="text-gray-600">{faq.a}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default FAQPage;